module.exports = __webpack_public_path__ + "img/flex-back-small.a1a80409.png";